import React from 'react';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import Button from '../../components/SelfInspect/SelfInspectButton';
import { withStyles } from '@material-ui/core';
import classNames from 'classnames';

const TRANSITION_TIME = '0.25s';

const styles = theme => {
  const smallScreenUpBp = '@media (min-width:375px)';

  return {
    button: {
      display: 'contents',
      backgroundColor: 'transparent',
      boxShadow: 'none',
      color: '#000A',
      borderColor: '#0003',

      [smallScreenUpBp]: {
        display: 'inherit',
      },
    },
    text: {
      visibility: 'hidden',
      width: 0,

      [smallScreenUpBp]: {
        visibility: 'visible',
        width: 'auto',
      },
    },

    iconContainer: {
      border: '2px solid #0003',
      borderRadius: 'inherit',
      aspectRatio: 1,

      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      marginRight: 'inherit',

      [smallScreenUpBp]: {
        border: 'none',
        position: 'relative',
        width: 21,
        aspectRatio: 'auto',
        marginRight: 'unset',
      },
    },

    icon: {
      display: 'flex',
      width: '0.9em',
      height: '0.9em',

      [smallScreenUpBp]: {
        position: 'absolute',
        transform: 'translate(-70%, -50%)',
        transform: 'translate(-6px, 0)',
        width: '1em',
        height: '1em',
      },
    },
  };
};

const SelfInspectBackButton = withStyles(styles)(({ style = {}, classes, className, ...props }) => {
  return (
    <Button
      {...props}
      style={style}
      className={classNames(classes.button, className)}
      label={
        <>
          <span className={classes.iconContainer}>
            <ChevronLeft className={classes.icon} fontSize="large" />
          </span>

          <span className={classes.text}>Back</span>
        </>
      }
    ></Button>
  );
});

export default SelfInspectBackButton;
